const AbstractCloverRequestRecord = require('./AbstractCloverRequestRecord');
const CloverReceiptDeliveryMethod = require('@/lib/PaymentMethods/Clover/Enums/CloverReceiptDeliveryMethod');

class CloverReceiptPaymentRequestRecord extends AbstractCloverRequestRecord {
    /**
     * @param {string} paymentId // A uuid.
     * @param {} deliveryOption
     */
    constructor(paymentId, deliveryOption) {
        if (!paymentId || paymentId.trim() === '') {
            throw new Error('paymentId is required');
        }
        if (
            // @Todo test against actual DeliveryOption object.
            !deliveryOption
            || !deliveryOption.method
            || !CloverReceiptDeliveryMethod.hasOwnProperty(deliveryOption.method)
        ) {
            const methods = Object.values(CloverReceiptDeliveryMethod).join(', ');
            throw new Error('deliveryOption is required and must be one of ' + methods);
        }
        // @link https://docs.clover.com/reference/receipt_options
        const url = '/connect/v1/payments/' + paymentId + '/receipt';
        super(
            'POST',
            url
        );
        this.data = {
            // printJobId,
            deliveryOption,
        };
    }
}

module.exports = CloverReceiptPaymentRequestRecord;
